(() => {
  const groups = ['format','edition','sound','type','era','language'];
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const messages = JSON.parse(root.querySelector('[data-catalog-messages]').textContent);
    const searchForm = root.querySelector('.sjelf-catalog__search'), search = searchForm.elements.q;
    const filterForm = root.querySelector('[data-filter-form]'), sort = root.querySelector('[data-catalog-sort]');
    const grid = root.querySelector('[data-catalog-grid]'), empty = root.querySelector('[data-empty]');
    const selection = root.querySelector('[data-selection]'), status = root.querySelector('[data-status]');
    const pagination = root.querySelector('[data-pagination]'), dialog = root.querySelector('dialog');
    const controls = Object.fromEntries(groups.map(g => [g, [...filterForm.querySelectorAll('input[name="'+g+'"]')]]));
    const media = matchMedia('(max-width:899px)'), locked = root.dataset.scope === 'pre-loved';
    const desktopScroll = matchMedia('(min-width:990px)'), pageWrapper = root.closest('.page-wrapper');
    const scrollPosition = () => desktopScroll.matches && pageWrapper ? pageWrapper.scrollTop : window.scrollY;
    const restoreScroll = y => (desktopScroll.matches && pageWrapper ? pageWrapper : window).scrollTo({top:y,left:0,behavior:'instant'});
    desktopScroll.addEventListener('change',event=>{if(!pageWrapper)return;const y=event.matches?window.scrollY:pageWrapper.scrollTop;if(event.matches)window.scrollTo({top:0,left:0,behavior:'instant'});restoreScroll(y);});
    const number = value => Number(value).toLocaleString(document.documentElement.lang || 'nl');
    let revision = 0, timer, loadingTimer, controller, page = 1, readyPromise, engine, worker, messageId = 0;
    let loadedFormats = 1, readyFormatMask = 0;
    let initial = true, pendingJobs = new Map(), cardCache = new Map(), lastResult, initializedAt = 0;
    const publicURL = (value) => {
      const url = new URL(value, location.origin);
      if (url.protocol !== 'https:' || !(url.origin === location.origin || url.hostname === 'cdn.shopify.com')) throw Error('Invalid catalog location');
      return url;
    };
    const read = () => {
      const state = {q:search.value.trim(),scope:root.dataset.scope,sort:sort.value,min:filterForm.elements.min.value,max:filterForm.elements.max.value,page};
      for (const group of groups) state[group] = controls[group].reduce((mask,input) => input.checked ? mask | (1 << Number(input.dataset.bit)) : mask,0);
      if (locked) state.edition |= 16;
      return state;
    };
    const hasSelection = state => state.q || groups.some(g => g === 'edition' && locked ? state[g] !== 16 : state[g]) || state.min !== '' || state.max !== '';
    const paramFor = group => group === 'format' ? 'sjelf_format' : group === 'type' ? 'sjelf_type' : group;
    function fromURL() {
      const params = new URL(location.href).searchParams;
      search.value = params.get('q') || '';
      const routeEditions = {'new-releases':'new-release','pre-orders':'pre-order','box-sets':'box-set','coloured-vinyl':'coloured','pre-loved':'pre-loved','selected-vinyl':'pre-loved'};
      const routeDefault = params.has('edition') || !initial ? '' : routeEditions[root.dataset.route];
      for (const group of groups) {
        const formatDefault = initial && !params.has(paramFor('format')) ? ({vinyl:'vinyl',cd:'cd',cassettes:'cassette'}[root.dataset.route] || '') : '';
        const values = (params.get(paramFor(group)) || (group === 'type' ? params.get('type') : '') || (group === 'edition' ? routeDefault : group === 'format' ? formatDefault : '') || '').split(',');
        for (const input of controls[group]) {
          input.checked = values.includes(input.value) || input.hasAttribute('data-locked');
          input.disabled = input.hasAttribute('data-locked');
          if (input.checked) input.closest('details').open = true;
        }
      }
      if (initial) {
        const oldTags = JSON.parse(root.dataset.tags || '[]') || [];
        const topics = {'SJELF: KERST':'kerst','SJELF: SOUNDTRACK':'soundtrack','SJELF: LIVE':'live','SJELF: UNPLUGGED':'unplugged'};
        for (const input of controls.type) if (oldTags.some(t => topics[t] === input.value)) input.checked = true;
      }
      for (const key of ['min','max']) {
        const raw = params.get(key);
        filterForm.elements[key].value = raw !== null && Number.isFinite(Number(raw)) && Number(raw) >= 0 ? raw : '';
        if (filterForm.elements[key].value !== '') filterForm.elements[key].closest('details').open = true;
      }
      sort.value = ['manual','price-ascending','price-descending','title-ascending'].includes(params.get('sort_by')) ? params.get('sort_by') : 'manual';
      page = Math.max(1,Math.trunc(Number(params.get('page'))) || 1);
    }
    function urlFor(state) {
      const url = new URL(location.href);
      url.pathname = root.dataset.path;
      url.hash = '';
      for (const key of [...groups,...groups.map(paramFor),'q','min','max','sort_by','page']) url.searchParams.delete(key);
      if (state.q) url.searchParams.set('q',state.q);
      for (const group of groups) {
        const values = controls[group].filter(input => state[group] & (1 << Number(input.dataset.bit))).filter(input => !input.hasAttribute('data-locked')).map(input => input.value);
        if (values.length) url.searchParams.set(paramFor(group),values.join(','));
      }
      if (state.min !== '') url.searchParams.set('min',state.min);
      if (state.max !== '') url.searchParams.set('max',state.max);
      if (state.sort !== 'manual') url.searchParams.set('sort_by',state.sort);
      if (state.page > 1) url.searchParams.set('page',String(state.page));
      return url;
    }
    function setURL(mode,state) {
      const url = urlFor(state);
      if (url.href !== location.href) history[mode === 'push' ? 'pushState' : 'replaceState']({...history.state,sjelfCatalog:true},'',url);
    }
    function chip(label, action) {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'sjelf-catalog__chip';
      button.append(document.createTextNode(label));
      const x = document.createElement('span'); x.textContent='×'; x.setAttribute('aria-hidden','true'); button.append(x);
      button.setAttribute('aria-label', messages.remove + ': ' + label); button.addEventListener('click',action);
      selection.append(button);
    }
    function paintSelection(state) {
      selection.replaceChildren();
      if (state.q) chip('“'+state.q+'”',()=>{search.value='';change('push');});
      for (const group of groups) for (const input of controls[group]) {
        if (!input.checked || input.hasAttribute('data-locked')) continue;
        chip(input.nextElementSibling.textContent,()=>{input.checked=false;change('push');});
      }
      if (state.min !== '' || state.max !== '') chip(messages.price + ': €'+(state.min || '0')+' – '+(state.max !== '' ? '€'+state.max : '∞'),()=>{filterForm.elements.min.value='';filterForm.elements.max.value='';change('push');});
      if (hasSelection(state)) {
        const clear = document.createElement('button'); clear.type='button';clear.className='sjelf-catalog__clear';clear.textContent=messages.reset;clear.addEventListener('click',reset);selection.append(clear);
      }
      const count = [...filterForm.querySelectorAll('input[type=checkbox]:checked:not([data-locked])')].length + Number(state.min!=='' || state.max!=='');
      root.querySelector('[data-active-count]').textContent=count ? '('+count+')' : '';
    }
    async function ready(state) {
      const requestedFormats = state.format || 7;
      if (readyPromise && (readyFormatMask & requestedFormats) === requestedFormats) return readyPromise;
      if (readyPromise) { await readyPromise; readyPromise = null; }
      readyFormatMask = requestedFormats;
      readyPromise = (async()=>{
        let manifest;
        try {manifest = JSON.parse(root.dataset.manifest);} catch(e) {}
        if (!manifest?.version || initializedAt || Date.now() - Date.parse(manifest.generatedAt) > 15*60*1000) {
          const u = new URL(root.dataset.searchUrl,location.origin);u.searchParams.set('view','sjelf-catalog-manifest');u.searchParams.set('q','*');u.searchParams.set('_catalog',String(Math.floor(Date.now()/60000)));
          const response = await fetch(u,{signal:AbortSignal.timeout(15000)});
          if (!response.ok) throw Error('Manifest unavailable');
          manifest = await response.json();
        }
        const indexURL = new URL(root.dataset.searchUrl,location.origin);
        indexURL.searchParams.set('view','sjelf-catalog-index');indexURL.searchParams.set('q','*');indexURL.searchParams.set('v',manifest.version);
        let payload;
        try {const cached=JSON.parse(sessionStorage.getItem('sjelf-catalog-index')||'null');if(cached?.payload?.manifest?.version===manifest.version && Date.now()-cached.time<300000)payload=cached.payload;}catch(e){}
        if (!payload) {
          const response = await fetch(indexURL,{signal:AbortSignal.timeout(25000)});
          if (!response.ok) throw Error('Catalog unavailable');
          payload = await response.json();
          try {sessionStorage.setItem('sjelf-catalog-index',JSON.stringify({time:Date.now(),payload}));}catch(e){}
        }
        manifest = payload.manifest;
        if (manifest?.encoding !== 'gzip-base64' || payload.chunks?.length !== manifest.chunks) throw Error('Invalid catalog encoding');
        const compressed = Uint8Array.from(atob(payload.chunks.join('')),c=>c.charCodeAt(0));
        const snapshot = JSON.parse(await new Response(new Blob([compressed]).stream().pipeThrough(new DecompressionStream('gzip'))).text());
        if (snapshot.version !== manifest.version || snapshot.rows?.length !== manifest.count) throw Error('Catalog version mismatch');
        loadedFormats = 1;
        if (requestedFormats & 6) {
          snapshot.formats = {...snapshot.formats};
          const seen = new Set(snapshot.rows.map(row => row[0]));
          // Cache only complete page responses, with the same five-minute freshness window.
          const getPage = async (scope, pageNumber) => {
            const key = 'sjelf-format-v2:' + manifest.version + ':' + scope + ':' + pageNumber;
            try {const cached=JSON.parse(sessionStorage.getItem(key)||'null');if(cached && Date.now()-cached.time<300000)return cached.data;}catch(e){}
            const url = new URL(root.dataset.searchUrl,location.origin);
            url.searchParams.set('view','sjelf-catalog-'+scope);url.searchParams.set('q','*');url.searchParams.set('page',String(pageNumber));
            const response=await fetch(url,{signal:AbortSignal.timeout(25000)});
            if(!response.ok)throw Error('Catalog format unavailable');
            const data=await response.json();
            if(!Array.isArray(data.products))throw Error('Invalid format page');
            try {sessionStorage.setItem(key,JSON.stringify({time:Date.now(),data}));}catch(e){}
            return data;
          };
          const formatPages=new Map();
          const scopes=[...(requestedFormats & 2 ? ['cd'] : []), ...(requestedFormats & 4 ? ['cassettes'] : [])];
          const firstPages=await Promise.all(scopes.map(scope=>getPage(scope,1)));
          const jobs=[];
          scopes.forEach((scope,i)=>{formatPages.set(scope+':1',firstPages[i]);for(let n=2;n<=(Number(firstPages[i].pages)||1);n++)jobs.push([scope,n]);});
          let jobIndex=0;
          await Promise.all(Array.from({length:Math.min(4,jobs.length)},async()=>{while(jobIndex<jobs.length){const [scope,n]=jobs[jobIndex++];formatPages.set(scope+':'+n,await getPage(scope,n));}}));
          for (const scope of scopes) {
            loadedFormats |= scope === 'cd' ? 2 : 4;
            let nextPage = 1, pages = 1;
            do {
              const extra = formatPages.get(scope+':'+nextPage);
              pages = Number(extra.pages) || 1;
              for (const product of extra.products) {
                snapshot.formats[product.handle] = scope === 'cd' ? 'cd' : 'cassette';
                if (seen.has(product.handle)) continue;
                seen.add(product.handle);
                const tags = product.tags.map(t => t.toLowerCase().replace(/[^a-z0-9]+/g,' ').trim());
                const has = value => tags.some(tag => tag === value || tag.replace(/^(sjelf )?(sound|genre|language|taal|era|edition|type) /,'').replace(/^sjelf /,'') === value);
                const mask = values => values.reduce((n,value,i) => has(value) ? n | (1<<i) : n,0);
                const edition = mask(['pre order','coloured vinyl','box set','new release','pre loved']);
                const sounds = [['pop indie','pop','indie','indie pop'],['rock alternative','rock','alternative rock','grunge'],['punk hardcore','punk','hardcore'],['metal industrial','metal','heavy metal','industrial'],['hip hop rap','hip hop','rap'],['soul r b','soul','r b'],['funk disco','funk','disco'],['jazz blues','jazz','blues'],['electronic dance','electronic','dance','house','techno'],['ambient experimental','ambient','experimental'],['reggae dub','reggae','dub'],['folk country','folk','country'],['classical neoclassical','classical','neoclassical'],['global heritage','world','world music']];
                const sound = sounds.reduce((n,aliases,i)=>aliases.some(has) ? n | (1<<i) : n,0);
                const type = mask(['kerst','soundtrack','live','unplugged','compilatie']);
                const languages = [['dutch','nederlands'],['english','engels'],['french','frans'],['german','duits'],['spanish','spaans'],['italian','italiaans'],['portuguese','portugees'],['japanese','japans'],['korean','koreaans'],['multilingual','meertalig'],['instrumental','instrumentaal']];
                const language = languages.reduce((n,aliases,i)=>aliases.some(has) ? n | (1<<i) : n,0);
                const era = ['1950 earlier','1960','1970','1980','1990','2000','2010','2020'].findIndex(value=>has(value));
                snapshot.rows.push([product.handle,product.title,product.artist,product.price,sound,era,language,edition,type]);
              }
              nextPage++;
            } while (nextPage <= pages);
          }
        }
        if (worker) worker.terminate();
        pendingJobs.forEach(job=>job.reject(Error('Catalog refreshed')));pendingJobs.clear();
        try {
          const script = await fetch(publicURL(root.dataset.worker),{signal:AbortSignal.timeout(12000)});
          if (!script.ok) throw Error('Worker unavailable');
          const blob = URL.createObjectURL(new Blob([await script.text()],{type:'application/javascript'}));
          worker = new Worker(blob);URL.revokeObjectURL(blob);
          worker.onmessage = event => {const job=pendingJobs.get(event.data.id);if(!job)return;pendingJobs.delete(event.data.id);clearTimeout(job.timeout);event.data.error?job.reject(Error(event.data.error)):job.resolve(event.data.result || event.data);};
          worker.onerror = () => {pendingJobs.forEach(job=>{clearTimeout(job.timeout);job.reject(Error('Worker failed'));});pendingJobs.clear();};
          await sendWorker({kind:'init',snapshot});
          engine = null;
        } catch(e) {worker?.terminate();worker=null;engine=new window.SjelfCatalogEngine(snapshot);}
        initializedAt = Date.now();
      })().catch(error=>{readyPromise=null;throw error;});
      return readyPromise;
    }
    function sendWorker(payload) {
      return new Promise((resolve,reject)=>{const id=++messageId;const timeout=setTimeout(()=>{pendingJobs.delete(id);reject(Error('Worker timed out'));},20000);pendingJobs.set(id,{resolve,reject,timeout});worker.postMessage({id,...payload});});
    }
    async function cards(handles,signal) {
      if (!handles.length) return '';
      const key=handles.join('|'), cached=cardCache.get(key);
      if (cached && Date.now()-cached.time<30000) return cached.html;
      const url=new URL(root.dataset.searchUrl,location.origin);url.searchParams.set('view','sjelf-catalog-cards');url.searchParams.set('type','product');url.searchParams.set('q',key);
      const response=await fetch(url,{signal:AbortSignal.any([signal,AbortSignal.timeout(15000)])});
      if (!response.ok) throw Error('Cards unavailable');
      const doc=new DOMParser().parseFromString(await response.text(),'text/html');
      const container=doc.querySelector('[data-catalog-cards]');
      if (!container) throw Error('Invalid card response');
      await Promise.race([Promise.all([...container.querySelectorAll('img.sjelf-tile__cover')].slice(0,4).map(img=>new Promise(resolve=>{const preload=new Image();preload.onload=preload.onerror=resolve;preload.sizes=img.sizes;preload.srcset=img.srcset;preload.src=img.src;}))),new Promise(resolve=>setTimeout(resolve,800))]);
      if(signal.aborted)throw new DOMException('Aborted','AbortError');
      const html=container.innerHTML;
      if (cardCache.size>=12) cardCache.delete(cardCache.keys().next().value);
      cardCache.set(key,{html,time:Date.now()});return html;
    }
    function paintPagination(result,state) {
      pagination.replaceChildren();
      if (result.pages<=1) return;
      const add=(n,label,aria)=>{
        if (n===result.page) {const span=document.createElement('span');span.textContent=label;span.setAttribute('aria-current','page');pagination.append(span);return;}
        const a=document.createElement('a');a.textContent=label;a.href=urlFor({...state,page:n});a.setAttribute('aria-label',aria || messages.page+' '+n);a.addEventListener('click',e=>{e.preventDefault();page=n;invalidate();update('push',true);});pagination.append(a);
      };
      if (result.page>1) add(result.page-1,'←',messages.previous);
      const visible=new Set([1,result.pages,result.page-1,result.page,result.page+1]);
      let previous=0;
      for (const n of [...visible].filter(n=>n>=1&&n<=result.pages).sort((a,b)=>a-b)) {if(previous&&n-previous>1){const dots=document.createElement('span');dots.textContent='…';pagination.append(dots);}add(n,String(n));previous=n;}
      if (result.page<result.pages) add(result.page+1,'→',messages.next);
    }
    function paintCounts(result) {
      for (const group of groups) for (const input of controls[group]) {
        const count=result.counts[group][Number(input.dataset.bit)];
        const unknownFormat = group === 'format' && !(loadedFormats & (1 << Number(input.dataset.bit)));
        input.closest('label').querySelector('[data-filter-count]').textContent=unknownFormat ? '' : number(count);
        input.disabled=input.hasAttribute('data-locked') || (!unknownFormat && !input.checked && count===0);
      }
      if(initial && locked) for(const group of ['sound','era','language']) {
        if(result.counts[group].every(count=>count===0) && !controls[group].some(input=>input.checked))controls[group][0].closest('details').open=false;
      }
      root.querySelector('[data-total]').textContent=number(result.total)+' '+(result.total===1 ? messages.record : messages.records);
      root.querySelector('[data-drawer-count]').textContent='('+number(result.total)+')';
    }
    function invalidate() {
      revision++;clearTimeout(timer);clearTimeout(loadingTimer);controller?.abort();
      grid.setAttribute('aria-busy','true');
      for(const group of groups) for(const input of controls[group]) input.disabled=input.hasAttribute('data-locked');
    }
    function simpleRoute(state) {
      if(state.q || state.min!=='' || state.max!=='' || state.sound || state.type || state.era || state.language || state.sort!=='manual')return null;
      if(state.edition===16 && !state.format)return 'pre-loved';
      if(state.edition===1 && !state.format)return 'pre-orders';
      if(state.edition)return null;
      return {0:'music',1:'vinyl',2:'cd',4:'cassettes'}[state.format] || null;
    }
    async function update(mode='replace',scroll=false) {
      // Use Shopify's already rendered collection for simple entry routes.
      // No 24,000-product client index is needed just to open CD or VINYL.
      const entryState=read(), entryRoute=simpleRoute(entryState);
      if(initial && entryRoute===root.dataset.route && !new URL(location.href).searchParams.has('q')) {
        paintSelection(entryState);grid.setAttribute('aria-busy','false');status.textContent='';initial=false;return;
      }
      const ticket=++revision,state=read();
      if (state.min!=='' && state.max!=='' && Number(state.min)>Number(state.max)) {status.textContent=messages.invalidPrice;grid.setAttribute('aria-busy','false');return;}
      setURL(mode,state);paintSelection(state);
      controller=new AbortController();const signal=controller.signal;
      grid.setAttribute('aria-busy','true');status.textContent='';
      loadingTimer=setTimeout(()=>{if(ticket===revision)status.textContent=messages.loading;},250);
      try {
        let readyTimeout;
        try { await Promise.race([ready(state), new Promise((_,reject)=>{readyTimeout=setTimeout(()=>reject(Error('Catalog load timed out')),30000);})]); }
        finally { clearTimeout(readyTimeout); }
        if(ticket!==revision)return;
        const result=worker ? await sendWorker({kind:'filter',state}) : engine.run(state);
        if(ticket!==revision)return;
        const keepInitial=initial && !hasSelection(state) && state.sort==='manual' && state.page===1;
        const html=keepInitial ? null : await cards(result.handles,signal);
        if(ticket!==revision)return;
        page=result.page;state.page=page;setURL('replace',state);
        if(html!==null) grid.innerHTML=html;
        grid.hidden=result.total===0;empty.hidden=result.total!==0;
        paintCounts(result);paintPagination(result,state);lastResult=result;
        clearTimeout(loadingTimer);status.textContent='';grid.setAttribute('aria-busy','false');
        root.dispatchEvent(new CustomEvent('sjelf:catalog-updated',{bubbles:true,detail:{total:result.total}}));
        if(scroll) root.querySelector('.sjelf-catalog__toolbar').scrollIntoView({block:'start',behavior:'auto'});
        if(initial && performance.getEntriesByType('navigation')[0]?.type==='back_forward') {
          try {const saved=JSON.parse(sessionStorage.getItem('sjelf-catalog-scroll')||'null');if(saved?.url===location.pathname+location.search && Date.now()-saved.time<1800000)requestAnimationFrame(()=>restoreScroll(saved.y));}catch(e){}
        }
        initial=false;
      } catch(error) {
        if(ticket!==revision || signal.aborted)return;
        clearTimeout(loadingTimer);grid.setAttribute('aria-busy','false');status.replaceChildren(document.createTextNode(messages.error+' '));
        const retry=document.createElement('button');retry.type='button';retry.textContent=messages.retry;retry.addEventListener('click',()=>{invalidate();update();});status.append(retry);
      }
    }
    function change(mode='push',delay=0) {
      page=1;
      const route=simpleRoute(read());
      if(route) {location.assign(new URL(root.dataset.path,location.origin).pathname.replace(/[^/]+$/,route));return;}
      invalidate();paintSelection(read());
      if(delay) timer=setTimeout(()=>update(mode),delay);else update(mode);
    }
    function reset() {
      search.value='';filterForm.elements.min.value='';filterForm.elements.max.value='';
      for(const group of groups)for(const input of controls[group])input.checked=input.hasAttribute('data-locked');
      change('push');
    }
    function adaptDialog() {if(media.matches){if(dialog.open)dialog.close();}else{if(dialog.matches(':modal'))dialog.close();dialog.setAttribute('open','');}}
    fromURL();adaptDialog();media.addEventListener('change',adaptDialog);
    root.querySelector('[data-open-filters]').addEventListener('click',()=>dialog.showModal());
    root.querySelectorAll('[data-close-filters]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
    dialog.addEventListener('click',e=>{if(e.target===dialog&&media.matches){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)dialog.close();}});
    searchForm.addEventListener('submit',e=>{e.preventDefault();change('replace');});
    search.addEventListener('input',()=>change('replace',250));
    search.addEventListener('search',()=>change('replace',0));
    filterForm.addEventListener('submit',e=>{e.preventDefault();change('push');});
    filterForm.addEventListener('change',e=>{if(e.target.type==='checkbox')change('push');else change('replace');});
    filterForm.addEventListener('input',e=>{if(e.target.type==='number')change('replace',450);});
    sort.addEventListener('change',()=>change('push'));
    root.querySelectorAll('[data-reset]').forEach(button=>button.addEventListener('click',reset));
    window.addEventListener('popstate',()=>{invalidate();fromURL();update('replace');});
    root.addEventListener('click',e=>{if(e.target.closest('a[href*="/products/"]'))try{sessionStorage.setItem('sjelf-catalog-scroll',JSON.stringify({url:location.pathname+location.search,y:scrollPosition(),time:Date.now()}));}catch(err){}});
    document.addEventListener('visibilitychange',()=>{if(!document.hidden&&initializedAt&&Date.now()-initializedAt>300000){readyPromise=null;cardCache.clear();invalidate();update('replace');}});
    paintSelection(read());update('replace');
  }
  const start=()=>document.querySelectorAll('[data-sjelf-catalog]').forEach(setup);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();



